module.exports = __webpack_public_path__ + "static/media/40-12.bb20b3b7.mp3";